import { Box } from '@factorialco/deprecated-design-system'
import { motion } from 'framer-motion'

import { observer } from 'mobx-react'

import Portal from 'modules/core/components/Portal'

import FileViewer from 'modules/expenses/components/FileViewer/Viewer'
import { useFilesPreviewer } from 'modules/expenses/components/expenses/Detail/hooks/useFilesPreviewer'

import * as styles from './index.vanilla.css'

interface FilesPreviewerProps {
  onClose: () => void
  onDrop?: (files: File[]) => void
  showUploadButton?: boolean
  isFilesFieldEnabled?: boolean
}

const FilesPreviewer = ({
  onClose,
  onDrop,
  showUploadButton = false,
  isFilesFieldEnabled = true,
}: FilesPreviewerProps) => {
  const { files, selectedFile, selectFile } = useFilesPreviewer()

  return (
    <Portal onClose={onClose}>
      <motion.div
        key="files-previewer-animation"
        initial={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={styles.overlay}
      >
        <Box className={styles.fileViewer}>
          <FileViewer
            currentFile={selectedFile}
            isPending={!selectedFile}
            files={files}
            onSelectFile={selectFile}
            onDrop={onDrop}
            showUploadButton={showUploadButton}
            isFilesFieldEnabled={isFilesFieldEnabled}
          />
        </Box>
      </motion.div>
    </Portal>
  )
}

export default observer(FilesPreviewer)
